<template>
  <div>
    <!-- TABELA -->
    <v-layout v-if="!isNewRequest" wrap row xs12>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-tooltip bottom> -->
        <v-btn fab dark color="primary" class="mb-2" @click.prevent="addNewRequest();" :loading="loading">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- <span>Tooltip</span>
                </v-tooltip>-->
      </v-toolbar>
      <v-data-table :headers="headers" :search="search" rows-per-page-text="Registros por Página"
        :rows-per-page-items="[5, 10, 30, 50]" :items="requests" class="elevation-1" style="width: 100%"
        :loading="loading" :pagination.sync="pagination" item-key="requestCode">
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{props.item.requestCode }}</td>
          <td class="text-xs-center">{{utilFormatter.formatDateISOToBR( props.item.requestDate)}}</td>
          <td class="text-xs-center">
            <v-chip small class="font-weight-light" color="#f1f1f1">{{props.item.requestType}}</v-chip>
          </td>
          <td class="text-xs-center">{{ props.item.contractCode ? props.item.contractCode :""}}</td>
          <td class="text-xs-center">
            <v-chip small class="font-weight-light" :color="props.item.situation.color">
              {{props.item.situation.title || 'Teste'}}</v-chip>
          </td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <strong>{{footerDynamicText}}</strong>
        </template>
        <div slot="no-results" :value="true">
          <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
        </div>
      </v-data-table>
    </v-layout>
    <!-- TABELA -->

    <!-- Request -->
    <v-layout v-else wrap row>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.prevent="cancelNewRequest();" title="Cancelar">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider vertical class="ml-2 mr-2" inset dark></v-divider>
          <v-btn @click.prevent="save" title="Salvar Requisição" color="primary" small depressed>
            Salvar Requisição
            <v-icon right>save</v-icon>
          </v-btn>
          <v-btn @click.prevent="download" title="Download Requisição" color="primary" small depressed>
            Download Requisição
            <v-icon right>cloud</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid grid-list-lg>
        <v-alert :value="alert" :color="alertType" dismissible class="mb-3">{{msgAlert}}</v-alert>

        <v-expansion-panel v-model="panel" expand>
          <!-- DADOS GERAIS DA REQUISIÇÂO -->
          <v-expansion-panel-content>
            <template v-slot:header>
              <h1 class="headline font-weight-bold pa-2 grey--text text--darken-1">Dados Gerais do Pedido</h1>
            </template>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 sm6 py-0>
                  <v-autocomplete :readonly="isEditing" label="Empresa" v-model="contract.company" item-value="_id"
                    :items="companies" :item-text="companyText" return-object dense flat box
                    no-data-text="Nenhuma empresa encontrada"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 py-0>
                  <v-autocomplete label="Cliente (Contratante)" :readonly="isEditing" v-model="contract.client"
                    :items="clients" item-value="_id" :item-text="clientText" return-object dense flat box
                    no-data-text="Nenhum cliente encontrado"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md8 py-0>
                  <v-autocomplete label="Supervisor Responsável" v-model="contract.supervisor" :readonly="isEditing"
                    item-value="_id" :items="users" item-text="name" return-object dense flat box
                    no-data-text="Nenhum responsável encontrado"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3 md4 py-0>
                  <v-text-field type="number" v-model="contract.sendDate" label="Dia de Envio" :readonly="isEditing"
                    box></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6 py-0>
                  <v-layout row wrap class="ma-0">
                    <v-autocomplete label="Situação" v-model="request.situation" item-value="title" :items="situations"
                      :item-text="situationText" return-object dense box :disabled="situationEditDisabled">
                    </v-autocomplete>
                    <v-btn style="float: right" dark color="primary" fab small
                      @click="situationEditDisabled = !situationEditDisabled">
                      <v-icon class="white--text" v-if="situationEditDisabled">edit</v-icon>
                      <v-icon class="white--text" v-else>check</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md6 py-0>
                  <v-layout row wrap class="ma-0">
                    <v-autocomplete label="Tipo de Requisição" v-model="request.requestType" item-value="name"
                      :items="requestTypes" return-object dense box :disabled="requestTypeEdit" :readonly="isEditing">
                    </v-autocomplete>
                    <v-btn :readonly="isEditing" style="float: right" dark color="primary" fab small
                      @click="requestTypeEdit = !requestTypeEdit">
                      <v-icon class="white--text" v-if="requestTypeEdit">edit</v-icon>
                      <v-icon class="white--text" v-else>check</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-expansion-panel-content>
          <!-- DADOS GERAIS DA REQUISIÇÂO -->

          <!-- SETOR -->
          <v-expansion-panel-content>
            <template v-slot:header>
              <h1 class="headline font-weight-bold pa-2 pb-0 grey--text text--darken-1">Setores</h1>
            </template>

            <v-container fluid grid-list-xl>
              <v-layout row wrap>
                <!-- GRID DE CARDS DE SETOR -->
                <v-flex xs12>
                  <v-container fluid grid-list-xl>
                    <v-layout row wrap class="pt-0">
                      <v-flex xs12 sm6 md4 v-for="(department, i) in contract.departments" :key="department._id">
                        <v-list two-line light class="py-0 elevation-2">
                          <v-list-tile>
                            <v-list-tile-content class="descoration" @click="editDepartment(i, department)">
                              <v-list-tile-title v-if="department.lastName">{{department.name +"-"+department.lastName}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                {{
                                department.numberOfEmployees>0
                                ? department.numberOfEmployees+' funcionário(s)'
                                : "Nenhum Funcionário Cadastrado"
                                }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                           <!--  <v-divider vertical inset></v-divider>
                            <v-list-tile-action class="descoration" @click="openDialogConfirm(department)">
                              <v-icon color="red" class="pr-2">delete_forever</v-icon>
                            </v-list-tile-action> -->
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <!-- CARD DO SETOR -->
              </v-layout>
            </v-container>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <template v-slot:header>
              <h1 class="headline font-weight-bold pa-2 pb-0 grey--text text--darken-1">Documentos</h1>
            </template>
            <upload-pdf ref="pdfs" :contractDocuments="request.requestDocuments"></upload-pdf>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-container>
    </v-layout>
    <!-- DIALOG EDIÇÃO DE SETOR -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogDepartment" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary" class="elevation-1">
            <v-btn icon dark @click="closeDialogDepartment" title="Cancelar">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Setor</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn @click="saveDepartment" title="Salvar Setor" color="primary" small depressed>
                Salvar
                <v-icon right>save</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout row wrap px-5>

            <v-flex xs12>
              <department @chengedSector="sendAddress" :finalizedContract="true"
                :contractHaveBudgetImported="contract.budgetImported" :contractDontHaveBudgetButIsFinished="true"
                :isPageRequest="true" ref="departmentForm" />
            </v-flex>
            <v-flex xs12 mt-5 mb-3>
              <v-expansion-panel v-model="panelDepartment" expand>
                <v-expansion-panel-content v-for="i in 4" :key="i">
                  <template v-slot:header>
                    <h1 class="headline font-weight-bold pa-2 grey--text text--darken-1">{{typesItems[i-1].title}}</h1>
                  </template>
                  <v-container fluid grid-list-xl>
                    <v-layout row wrap>
                      <list-products :productList="materials[typesItems[i-1].value].items"></list-products>
                    </v-layout>
                  </v-container>
                </v-expansion-panel-content>

              </v-expansion-panel>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- DIALOG EDIÇÃO DE SETOR -->

    <!-- NOVO CONTRATO -->

    <!-- DIALOG LOADING -->
    <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Carregando
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG LOADING -->
  </div>
</template>

<script>
  // SERVICES //
  import AnalyticalWorksheetService from '../service/AnalyticalWorksheetService.js'
  import BudgetService from '../service/BudgetService.js'
  import ContractService from '../service/ContractService.js'
  import RequestService from '../service/RequestService.js'
  import CompanyService from '../service/CompanyService.js'
  import PersonService from '../service/PersonService.js'
  import UserService from '../service/UserService.js'
  import UtilService from '../service/UtilService.js'
  import TypesOfSituations from '../utils/TypesOfSituations.js'
  import UtilFormatter from '../utils/UtilFormatter.js'
  import MessageFormatterUtil from '../utils/MessageFormatterUtil.js'
  import SystemConfigurationService from '../service/SystemConfigurationService'
  import CityService from '../service/CityService.js'

  // COMPONENTES
  import AnalyticalWorksheet from '../components/budget/AnalyticalWorksheet'
  import Department from '../components/contract/department/Department'
  import FormCity from '../components/budget/FormCity'
  import Tables from '../components/contract/department/Tables'
  import ListProducts from '../components/contract/Request/ListItems'
  import UploadPdf from "../components/contract/Uploads/UploadPdf"

  export default {
    components: {
      AnalyticalWorksheet,
      Tables,
      Department,
      ListProducts,
      FormCity,
      UploadPdf
    },

    data() {
      return {
        typesItems: [
          /*   {title:"", type:"",value:""}, */
          {
            title: 'Materiais de Consumo',
            type: 'Material de Consumo',
            value: 'consumables',
          },
          {
            title: 'Equipamentos',
            type: 'Equipamento',
            value: 'equipments',
          },
          {
            title: 'Utensílios',
            type: 'Utensílio',
            value: 'utensils',
          },
          {
            title: "Uniformes e EPI's",
            type: "Uniforme e EPI's",
            value: 'uniformsAndEPIs',
          },
        ],
        showDialogAddNewCity: false,
        panel: [false, false, false],
        panelDepartment: [false, false, false, false],
        cep: '',
        cities: [],
        contract: {
          client: {
            supervisorResponsibles: [],
          },
          situation: {},
          company: {
            address: {
              // Endereço
              cep: '',
              addressType: '', // Logradouro
              number: '',
              district: '',
              complement: '',
              city: '',
              state: '',
            },
          },
          departments: [],
        },

        pagination: {
          sortBy: 'requestCode',
          descending: true,
        },
        itemsKeys: ['requestCode', 'requestDate'],
        dialogDepartment: false,
        departmentIndex: -1,
        department: {
          professionalCategory: {},
          address: {},
        },
        materials: {
          consumables: {
            items: [],
          },
          equipments: {
            items: [],
          },
          uniformsAndEPIs: {
            items: [],
          },
          utensils: {
            items: [],
          },
        },
        editDepartmentItem: false,
        sectorType: 'SEDE',
        ationEditDisabled: true,
        dialogLoading: false,
        dialogImportBudget: false,
        dialogDepartment: false,
        utilFormatter: UtilFormatter,
        isNewRequest: true,
        isEditing: false,
        isSearchingAddress: false,
        situationEditDisabled: true,
        requestTypeEdit: true,

        // ALERT //
        msgAlert: '',
        alertType: '',
        alert: false,

        // CAMPOS //
        request: {
          requestDocuments:[]
        },
        companies: [],
        clients: [],
        users: [],
        budgets: [],
        sheetRemovable: {},
        situations: [],
        removeDialog: false,
        requestTypes: ['Reserva', 'Envio'],
        // TABELA //
        loading: false,
        requests: [],
        emptyRecordsText: 'Nenhum registro encontrado',
        emptySearchText: 'Nenhum registro encontrado para',
        search: '',
        editingSheet: {},
        headers: [{
            text: 'Código da Requisição',
            align: 'left',
            sortable: true,
            value: 'requestCode',
          },
          {
            text: 'Data da requisição',
            align: 'center',
            value: 'requestDate',
          },
          {
            text: 'Tipo de Requisição',
            align: 'center',
            value: 'requestType',
          },
          {
            text: 'Código do Contrato',
            align: 'center',
            value: 'contract.contractCode',
          },
          {
            text: 'Situação de Entrega',
            align: 'center',
            value: 'situation',
          },
          {
            text: 'Ações',
            align: 'center',
            value: 'name',
            sortable: false,
          },
        ],
      }
    },

    methods: {
      init() {
        this.alert = false
        this.contract = {
          client: {},
          situation: {},
          address: {},
        }
        this.loading = false
        this.isEditing = false
        this.dialogLoading = true
        this.isNewRequest = false
        this.dialogLoading = false
        this.editingSheet = {}
        this.department = {}
        this.findAllRequests()
      },

      buttonAddNewCity() {
        this.showDialogAddNewCity = true
      },
      closeDialogNewCity() {
        this.showDialogAddNewCity = false
        /* 430 */
      },
      savedCity() {
        this.fillCitiesTable()
        this.showDialogAddNewCity = false
      },
      findCityByNameAndState(address) {
        if (!this.cities) return

        for (let i = 0; i < this.cities.length; i++) {
          if (
            address.city.toUpperCase() ==
            this.cities[i].name.toUpperCase() &&
            address.state.toUpperCase() ==
            this.cities[i].state.toUpperCase()
          ) {
            return this.cities[i]
          }
        }
      },
      cityText: item => `${item.name} - ${item.state} (${item.uf})`,

      companyText: item => `${item.socialName} - ${item.fantasyName}`,

      clientText: item => {
        return item.isLegalPerson ?
          `${item.socialName} - ${item.fantasyName}` :
          `${item.name} - ${item.cpf}`
      },

      async addNewRequest() {
        this.dialogLoading = true
        await this.fillCompaniesTable()
        await this.fillClientsTable()
        await this.fillSituations()
        await this.fillUsersTable()
        await this.fillCitiesTable()
        this.dialogLoading = false
        this.isNewRequest = true
      },

      cancelNewRequest() {
        this.init()
      },

      async findAllRequests() {
        try {
          this.loading = true
          this.requests = await RequestService.findAll()
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      async fillCompaniesTable() {
        try {
          this.companies = await CompanyService.getCompaniesForSpecificData()
        } catch (error) {
          console.log(error)
        }
      },

      async fillCitiesTable() {
        try {
          this.cities = await CityService.getAll()
        } catch (error) {
          console.log(error)
        }
      },

      async fillClientsTable() {
        try {
          this.clients = await PersonService.getAll()
        } catch (error) {
          console.log(error)
        }
      },

      async fillUsersTable() {
        try {
          this.users = await UserService.getAll()
        } catch (error) {
          console.log(error)
        }
      },

      async fillSituations() {
        this.situations = [{
            title: 'AGUARDANDO APROVAÇÃO',
            color: '#f1f1f1',
          },
          {
            title: 'REPROVADO',
            color: 'red',
          },

          {
            title: 'AGUARDANDO ENTREGA',
            color: 'info',
          },
          {
            title: 'ENTREGUE',
            color: 'green',
          },
          {
            title: 'ENTREGUE C/ DEVOLUÇÂO',
            color: 'warning',
          },
        ]
      },
      situationText: item => `${item.title}`,

      async findAddressByCep() {
        if (this.contract != null) {
          try {
            if (
              this.contract.address.cep &&
              this.contract.address.cep.length == 8
            ) {
              this.isSearchingAddress = true
              this.contract.address = await UtilService.findAddressByCep(
                this.contract.address.cep
              )
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.isSearchingAddress = false
          }
        }
      },

      showAlert(message, type) {
        this.msgAlert = message
        this.alertType = type
        this.alert = true
      },

      editItem(item) {
        this.isEditing = true
        this.contract = Object.assign({}, item.contract)
        this.request = Object.assign({}, item)
        this.department = this.request.departments[0]
        this.addNewRequest()
      },

      async save() {
        this.dialogLoading = true
        this.request.requestDocuments = await this.$refs.pdfs.saveAllDocuments()
        let errors = RequestService.validade(this.request)
        if (errors) {
          this.showAlert(
            MessageFormatterUtil.formatErrorMessage(errors),
            'error'
          )
          this.dialogLoading = false
          return
        }
        try {
          if (this.isEditing) {
            await RequestService.update(this.request)
            this.showAlert('Registro alterado com sucesso', 'success')
          } else {
            await RequestService.create(this.request)
            this.showAlert('Registro salvo com sucesso', 'success')
          }
        } catch (error) {
          this.showAlert('Erro ao salvar o requisição', 'error')
          console.log(error)
        } finally {
          this.dialogLoading = false
        }
      },

      //###########################SETOR###########################//
      editDepartment(index, item) {
        this.editDepartmentItem = true
        this.$refs.departmentForm.editDepartment(item)
        this.materials = item.materials
        this.departmentIndex = index
        this.dialogDepartment = true
      },
      removeDepartment(item) {
        const index = this.contract.departments.indexOf(item)
        confirm('Are you sure you want to delete this item?') &&
          this.contract.departments.splice(index, 1)
      },

      async saveDepartment( /* department */ ) {
        let dep = this.$refs.departmentForm.saveDepartment()
        this.department = dep
        this.department.materials = await this.$refs.materialTables.save()
        if (this.editDepartmentItem) {
          this.contract.departments[
            this.departmentIndex
          ] = this.department
          this.editDepartmentItem = false
        } else {
          this.contract.departments.push(this.department)
        }

        this.closeDialogDepartment()
      },
      sendAddress() {
        this.$refs.departmentForm.setAddress(this.contract.company.address)
      },

      closeDialogDepartment() {
        this.$refs.departmentForm.resetDepartment()
        this.materials = {
          consumables: {
            items: [],
          },
          equipments: {
            items: [],
          },
          uniformsAndEPIs: {
            items: [],
          },
          utensils: {
            items: [],
          },
        }
        this.$refs.materialTables
        this.departmentIndex = -1
        this.dialogDepartment = false
        this.editDepartmentItem = false
      },

      resetDepartment(){
        this.department = {
          materials: {
            consumables: {
              items: []
            },
            equipments: {
              items: []
            },
            uniformsAndEPIs: {
              items: []
            },
            utensils: {
              items: []
            }
          }
        }
      },

      async download() {
        // let sheet = await BudgetService.download(this.contract._id)
        // var blob = new Blob([sheet], {
        //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
        // });
        // var url = window.URL.createObjectURL(blob)
        // window.open(url);
      },
    },

    computed: {
      footerDynamicText() {
        let text = this.loading ?
          this.loadingRecordsText :
          this.emptyRecordsText
        return text
      },
      formTitle() {
        return this.isEditing ? 'Requisição' : 'Nova Requisição'
      },
    },

    created() {
      this.init()
    },
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Request.vue